import { defineComponent as _defineComponent } from 'vue';
import { VContainer, VRow, VCol, VIcon } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosAvatarDemo',
    setup(__props) {
        return { __sfc: true, VContainer, VRow, VCol, VIcon, CodePreview, DemoSection };
    }
});
